
      const customCSSPropertiesMap = {
        "maxContentWidth": "--awsui-max-content-width-g964ok",
"minContentWidth": "--awsui-min-content-width-g964ok",
"breadcrumbsGap": "--awsui-breadcrumbs-gap-g964ok",
"contentGapLeft": "--awsui-content-gap-left-g964ok",
"contentGapRight": "--awsui-content-gap-right-g964ok",
"contentHeight": "--awsui-content-height-g964ok",
"contentLayoutDefaultHorizontalPadding": "--awsui-content-layout-default-horizontal-padding-g964ok",
"contentLayoutMaxContentWidth": "--awsui-content-layout-max-content-width-g964ok",
"contentLayoutMainGap": "--awsui-content-layout-main-gap-g964ok",
"defaultMaxContentWidth": "--awsui-default-max-content-width-g964ok",
"defaultMinContentWidth": "--awsui-default-min-content-width-g964ok",
"drawerSize": "--awsui-drawer-size-g964ok",
"footerHeight": "--awsui-footer-height-g964ok",
"headerGap": "--awsui-header-gap-g964ok",
"headerHeight": "--awsui-header-height-g964ok",
"layoutWidth": "--awsui-layout-width-g964ok",
"mainGap": "--awsui-main-gap-g964ok",
"mainOffsetLeft": "--awsui-main-offset-left-g964ok",
"mainTemplateRows": "--awsui-main-template-rows-g964ok",
"mobileBarHeight": "--awsui-mobile-bar-height-g964ok",
"notificationsHeight": "--awsui-notifications-height-g964ok",
"offsetTop": "--awsui-offset-top-g964ok",
"overlapHeight": "--awsui-overlap-height-g964ok",
"navigationWidth": "--awsui-navigation-width-g964ok",
"splitPanelReportedHeaderSize": "--awsui-split-panel-reported-header-size-g964ok",
"splitPanelReportedSize": "--awsui-split-panel-reported-size-g964ok",
"splitPanelHeight": "--awsui-split-panel-height-g964ok",
"splitPanelMinWidth": "--awsui-split-panel-min-width-g964ok",
"splitPanelMaxWidth": "--awsui-split-panel-max-width-g964ok",
"toolsMaxWidth": "--awsui-tools-max-width-g964ok",
"toolsWidth": "--awsui-tools-width-g964ok",
"toolsAnimationStartingOpacity": "--awsui-tools-animation-starting-opacity-g964ok",
"contentScrollMargin": "--awsui-content-scroll-margin-g964ok",
"flashbarStackDepth": "--awsui-flashbar-stack-depth-g964ok",
"flashbarStackIndex": "--awsui-flashbar-stack-index-g964ok",
"flashbarStickyBottomMargin": "--awsui-flashbar-sticky-bottom-margin-g964ok",
"stackedNotificationsBottomMargin": "--awsui-stacked-notifications-bottom-margin-g964ok",
"stackedNotificationsDefaultBottomMargin": "--awsui-stacked-notifications-default-bottom-margin-g964ok",
"dropdownDefaultMaxWidth": "--awsui-dropdown-default-max-width-g964ok",
"spinnerRotatorFrom": "--awsui-spinner-rotator-from-g964ok",
"spinnerRotatorTo": "--awsui-spinner-rotator-to-g964ok",
"spinnerLineLeftFrom": "--awsui-spinner-line-left-from-g964ok",
"spinnerLineLeftTo": "--awsui-spinner-line-left-to-g964ok",
"spinnerLineRightFrom": "--awsui-spinner-line-right-from-g964ok",
"spinnerLineRightTo": "--awsui-spinner-line-right-to-g964ok",
"sliderLabelCount": "--awsui-slider-label-count-g964ok",
"sliderTickCount": "--awsui-slider-tick-count-g964ok",
"sliderReferenceColumn": "--awsui-slider-reference-column-g964ok",
"sliderNextReferenceColumn": "--awsui-slider-next-reference-column-g964ok",
"sliderMaxStart": "--awsui-slider-max-start-g964ok",
"sliderMinEnd": "--awsui-slider-min-end-g964ok",
"sliderRangeInlineSize": "--awsui-slider-range-inline-size-g964ok",
"sliderTooltipPosition": "--awsui-slider-tooltip-position-g964ok",
"togglesLeftWidth": "--awsui-toggles-left-width-g964ok",
"togglesRightWidth": "--awsui-toggles-right-width-g964ok",
"promptInputMaxRows": "--awsui-prompt-input-max-rows-g964ok",
"promptInputScrollHeight": "--awsui-prompt-input-scroll-height-g964ok",
      };
      export default customCSSPropertiesMap;
    